import React from "react";
import { useLang } from "@/context/LangContext";

const CONTENT = {
    impressum: {
        en: {
            title: "Impressum",
            body: `Elite Player Academy
Frankfurt am Main, Germany

Name: Yauheni Andrayuk
Address: Windthorststraße 22, 65929 Frankfurt am Main, Germany

Contact:
Email: eliteplayeracademy1@gmail.com
Phone: +49 176 56759019

Responsible for content according to § 55 Abs. 2 RStV:
Yauheni Andrayuk
Windthorststraße 22, 65929 Frankfurt am Main, Germany

Disclaimer: The contents of this website have been created with the utmost care. However, no guarantee can be given for the correctness, completeness, or timeliness of the content.

External links: Our website contains links to external websites, over the content of which we have no influence. Therefore, we cannot accept any liability for these external contents.`
        },
        de: {
            title: "Impressum",
            body: `Elite Player Academy
Frankfurt am Main, Deutschland

Kontakt:
E-Mail: eliteplayeracademy1@gmail.com
Telefon: +49 15112345678

Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
[Vollständiger Name folgt]
[Vollständige Postanschrift folgt]
[Steuernummer / USt-IdNr. folgt]

Haftungsausschluss: Die Inhalte dieser Webseite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.

Externe Links: Unsere Webseite enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte können wir keine Gewähr übernehmen.`
        },
    },
    datenschutz: {
        en: {
            title: "Privacy Policy",
            body: `1. Overview
Personal data is any information that can identify you personally. This privacy policy explains what data we collect and how we use it.

2. Data collection on this website
Data controller: Elite Player Academy, eliteplayeracademy1@gmail.com

3. Purpose of processing
- Providing our football training programs and services
- Processing training bookings and payments
- Responding to your inquiries
- Legal obligations

4. Payment processing
We use Stripe as our payment processor. Payment details are transmitted directly to Stripe (Stripe Payments Europe, Ltd.) and are not stored on our servers. Please refer to Stripe's privacy policy.

5. Your rights
Under GDPR you have the right to information, correction, deletion, restriction, and data portability. Contact us to exercise these rights.

6. Cookies
See our Cookie policy for details.`
        },
        de: {
            title: "Datenschutzerklärung",
            body: `1. Überblick
Personenbezogene Daten sind alle Informationen, die persönlich identifizierbar sind. Diese Datenschutzerklärung informiert Sie darüber, welche Daten wir erheben und wie wir sie verwenden.

2. Datenerhebung auf dieser Website
Verantwortlicher: Elite Player Academy, eliteplayeracademy1@gmail.com

3. Zweck der Verarbeitung
- Bereitstellung unserer Fußball-Trainingsprogramme und -Dienste
- Bearbeitung von Trainingsanmeldungen und Zahlungen
- Beantwortung Ihrer Anfragen
- Gesetzliche Verpflichtungen

4. Zahlungsabwicklung
Wir nutzen Stripe als Zahlungsdienstleister. Zahlungsdaten werden direkt an Stripe (Stripe Payments Europe, Ltd.) übermittelt und nicht auf unseren Servern gespeichert. Bitte beachten Sie die Datenschutzerklärung von Stripe.

5. Ihre Rechte
Nach DSGVO haben Sie das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung und Datenübertragbarkeit. Kontaktieren Sie uns, um diese Rechte auszuüben.

6. Cookies
Details finden Sie in unserer Cookie-Erklärung.`
        },
    },
    cookies: {
        en: {
            title: "Cookie Policy",
            body: `Cookies are small text files stored on your device. We use them to make our website work, to remember your language preference, and to keep you signed in as an admin.

Types of cookies we use:
- Essential (session/auth) — required for the site to function
- Preferences (language) — remembers your EN/DE choice
- Payment (Stripe) — set by Stripe during checkout

You can disable cookies in your browser settings, but some functionality may be limited.`
        },
        de: {
            title: "Cookie-Richtlinie",
            body: `Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden. Wir nutzen sie, damit unsere Website funktioniert, um Ihre Spracheinstellung zu speichern und Admins angemeldet zu halten.

Von uns verwendete Cookie-Arten:
- Essenziell (Sitzung/Auth) — für die Funktion der Seite erforderlich
- Präferenzen (Sprache) — speichert Ihre EN/DE-Auswahl
- Zahlung (Stripe) — von Stripe im Checkout gesetzt

Sie können Cookies in Ihren Browsereinstellungen deaktivieren, dann sind allerdings einige Funktionen eingeschränkt.`
        },
    },
};

export default function LegalPage({ page }) {
    const { lang, t } = useLang();
    const c = CONTENT[page]?.[lang] || CONTENT[page]?.en;
    return (
        <div data-testid={`legal-${page}`} className="px-6 md:px-12 lg:px-20 py-16 max-w-4xl mx-auto">
            <div className="font-body text-xs uppercase tracking-[0.25em] text-volt mb-3">Legal</div>
            <h1 className="text-4xl md:text-5xl font-heading uppercase">{c.title}</h1>
            <pre className="mt-8 whitespace-pre-wrap font-body text-white/80 text-sm leading-relaxed">
                {c.body}
            </pre>
        </div>
    );
}
